// ExpandableBeskrivning — Kurzbeskrivning som alltid visas + valfri „Visa mer/Visa mindre".
// Etappe 4.11 — Pflegeansicht ↔ öffentliche Darstellung angleichen.
//
// Logik:
//   • Om kortbeskrivning + längre beskrivning finns → visa kortbeskrivning + expand-knapp.
//   • Om bara beskrivning finns och är lång (> threshold tecken) → trunkera + expand-knapp.
//   • Om bara beskrivning finns och är kort → visa direkt utan knapp.
//
// Användning:
//   <ExpandableBeskrivning kort={f.kortbeskrivning} full={f.beskrivning} testId="for-001" />
import { useState } from "react";

const DEFAULT_THRESHOLD = 220; // tecken

export default function ExpandableBeskrivning({
  kort,
  full,
  threshold = DEFAULT_THRESHOLD,
  testId,
  className = "",
}) {
  const [open, setOpen] = useState(false);

  const kortText = (kort || "").trim();
  const fullText = (full || "").trim();

  // Fall A: ingen beskrivning alls
  if (!kortText && !fullText) return null;

  // Fall B: kortbeskrivning + längre full → toggla mellan kort och full
  if (kortText && fullText && fullText !== kortText) {
    return (
      <div className={className}>
        <p
          data-testid={testId ? `${testId}-kort` : "beskrivning-kort"}
          className="text-sm text-bark leading-relaxed whitespace-pre-line"
        >
          {kortText}
        </p>
        {open && (
          <p
            data-testid={testId ? `${testId}-full` : "beskrivning-full"}
            className="text-sm text-bark/90 leading-relaxed whitespace-pre-line mt-2"
          >
            {fullText}
          </p>
        )}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          data-testid={testId ? `${testId}-toggle` : "beskrivning-toggle"}
          className="mt-1.5 text-xs font-semibold text-falu hover:text-falu-hover underline decoration-dotted underline-offset-2"
        >
          {open ? "Visa mindre" : "Visa mer"}
        </button>
      </div>
    );
  }

  // Fall C: bara en text (antingen kort eller full). Trunkera om för lång.
  const text = fullText || kortText;
  const tooLong = text.length > threshold;

  if (!tooLong) {
    return (
      <p
        data-testid={testId ? `${testId}-text` : "beskrivning-text"}
        className={`text-sm text-bark leading-relaxed whitespace-pre-line ${className}`}
      >
        {text}
      </p>
    );
  }

  const truncated = text.slice(0, threshold).trimEnd() + "…";
  return (
    <div className={className}>
      <p
        data-testid={testId ? `${testId}-text` : "beskrivning-text"}
        className="text-sm text-bark leading-relaxed whitespace-pre-line"
      >
        {open ? text : truncated}
      </p>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid={testId ? `${testId}-toggle` : "beskrivning-toggle"}
        className="mt-1.5 text-xs font-semibold text-falu hover:text-falu-hover underline decoration-dotted underline-offset-2"
      >
        {open ? "Visa mindre" : "Visa mer"}
      </button>
    </div>
  );
}
